import React from "react";

function isoWeek(date) {
  const d = new Date(date);
  d.setHours(0, 0, 0, 0);
  d.setDate(d.getDate() + 4 - (d.getDay() || 7));
  const yearStart = new Date(d.getFullYear(), 0, 1);
  return Math.ceil((((d - yearStart) / 86400000) + 1) / 7);
}

export default function DateStrip({
  selectedDate,
  selectedDateKey,
  stripDays,
  onSelectDateKey,
  onMoveWeek,
  onResetToToday,
}) {
  return (
    <div className="mtv2-datestrip">
      <div className="mtv2-monthchip">
        {selectedDate.toLocaleString("en-US", { month: "long" })}
        {" "}
        <em>week {isoWeek(selectedDate)}</em>
        <span className="yr">{selectedDate.getFullYear()} · IST</span>
      </div>
      <div className="mtv2-days">
        {stripDays.map((d) => (
          <button
            key={d.key}
            className={`mtv2-day${d.weekend ? " weekend" : ""}${d.today ? " today" : ""}${d.key === selectedDateKey ? " on" : ""}`}
            onClick={() => onSelectDateKey(d.key)}
          >
            {d.count > 0 && <span className="mtv2-count">{d.count}</span>}
            <div className="mtv2-day-dow">{d.dow}</div>
            <div className="mtv2-day-num">{d.num}</div>
            <div className="mtv2-day-sub">{d.mon}</div>
            <div className="mtv2-load"><i style={{ width: `${d.load}%` }} /></div>
          </button>
        ))}
      </div>
      <div className="mtv2-weeknav">
        <button title="Previous 7 days" onClick={() => onMoveWeek(-7)}>‹</button>
        <button title="Reset to today" onClick={onResetToToday}>·</button>
        <button title="Next 7 days" onClick={() => onMoveWeek(7)}>›</button>
      </div>
    </div>
  );
}
